import 'core-js/es/set';
import 'core-js/es/map';
import 'raf/polyfill';
import 'core-js';
import 'regenerator-runtime/runtime';
import 'babel-polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'antd-css-utilities/utility.min.css';
import locale from 'antd/lib/locale/ko_KR';
import { ConfigProvider as AntdProvider } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducer from './redux/reducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import './assets/css/antd.css';
import './assets/css/style.scss';
import './assets/css/_antd.scss';
import './assets/css/dashboard.scss';

const store = createStore(reducer, composeWithDevTools());

ReactDOM.render(
  <Provider store={store}>
    <AntdProvider locale={locale}>
      <App />
    </AntdProvider>
  </Provider>,
  document.getElementById('root')
);

store.subscribe(() => {});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
